/**
 * @description
 * Breadcrumb divider is usually only visual representation and therefore is hidden from screen readers.
 *
 * @specification
 * Adds attribute 'aria-hidden=true' to 'root' slot.
 */
export var breadcrumbDividerBehavior = function breadcrumbDividerBehavior() {
  return {
    attributes: {
      root: {
        'aria-hidden': true
      }
    }
  };
};
//# sourceMappingURL=breadcrumbDividerBehavior.js.map
